var map = {
	"./jianshiClick.png": "n6IB",
	"./shushiClick.png": "Hwiz",
	"./yingrenClick.png": "gkbU",
	"./youxiaClick.png": "3DGx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KPvt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage ^\.\/.*Click\.png$
// module id = KPvt
// module chunks = 0